module.exports = __webpack_public_path__ + "img/travel_step2_sucs.61380dbd.svg";